<template>
  <div class="Menue"></div>
</template>

<script>
export default {
  name: 'MessageMenu'
}
</script>

<style scoped>
.Menue{
    top:4.5rem;
    right: -6rem;
    position: absolute;
    width: 15rem;
    height: 20rem;
    background: red;
    z-index: 2000
  }
</style>
